<template>
  <p
    :class="`text-center text-[12px] font-medium rounded-full px-[4px] py-[2px] border-[1px] mb-0`"
    :style="{ backgroundColor: statusText.color.sub, color: statusText.color.main, borderColor: statusText.color.main }"
  >{{ statusText.label }}</p>
</template>

<script>
import { statusMapping } from './config'

export default {
  name: 'StatusOrderPill',
  props: {
    status: {
      type: String,
      default: 'Unknown',
    },
    mapping: {
      type: Object,
      default: () => statusMapping,
    },
  },
  computed: {
    defaultMapping() {
      return {
        label: 'Unknown',
        color: {
          main: '#000000',
          sub: '#E2E2E2',
        },
      }
    },
    statusText() {
      if (!this.mapping) {
        return this.defaultMapping
      }

      const status = this.mapping[this.status]

      if (status) {
        return status
      }

      return this.mapping.Unknown
    },
  },
}
</script>
